import React, { memo } from 'react';
import { Status as AkStatus } from '@atlaskit/status/element';
import { FabricElementsAnalyticsContext } from '@atlaskit/analytics-namespaced-context';
import { fg } from '@atlaskit/platform-feature-flags';
import { useInlineAnnotationProps } from '../../ui/annotations/element/useInlineAnnotationProps';
export default /*#__PURE__*/memo(function Status(props) {
  var text = props.text,
    color = props.color,
    localId = props.localId;
  var inlineAnnotationProps = useInlineAnnotationProps(props);
  if (fg('editor_inline_comments_on_inline_nodes')) {
    return (
      /*#__PURE__*/
      // Ignored via go/ees005
      // eslint-disable-next-line react/jsx-props-no-spreading
      React.createElement("span", inlineAnnotationProps, /*#__PURE__*/React.createElement(FabricElementsAnalyticsContext, {
        data: {
          userContext: 'document'
        }
      }, /*#__PURE__*/React.createElement(AkStatus, {
        text: text,
        color: color,
        localId: localId,
        role: "presentation",
        isBold: fg('platform-component-visual-refresh')
      })))
    );
  }
  return /*#__PURE__*/React.createElement(FabricElementsAnalyticsContext, {
    data: {
      userContext: 'document'
    }
  }, /*#__PURE__*/React.createElement(AkStatus, {
    text: text,
    color: color,
    localId: localId,
    role: "presentation",
    isBold: fg('platform-component-visual-refresh')
  }));
});